import * as yup from 'yup';

enum LogLevel {
  Error = 'error',
  Warn = 'warn',
  Info = 'info',
  Http = 'http',
  Verbose = 'verbose',
  Debug = 'debug',
}

export type EnvFile = {
  SERVER_URI: string;
  CLIENT_URI: string;
  UPS_URI: string;
  WP_ADMIN_URI: string;
  HOST_WS: string;
  PRODUCT_CREATION_ALLOWED: boolean;
  CACHE_EXPIRATION: number;
  RESEND_EMAIL_CODE_COOL_DOWN: number;
  IS_DEV: boolean;
  I18N_DEBUG: boolean;

  //Logger
  LOG_LEVEL: LogLevel;
  LOG_GROUP_NAME: string;
  LOG_STREAM_NAME: string;
  CLOUDWATCH_LOGGER_ENABLED: boolean;

  // AWS
  CLOUDWATCH_ACCESS_KEY: string;
  CLOUDWATCH_SECRET_ACCESS_KEY: string;
  CLOUDWATCH_REGION: string;
};

export const envFileValidationSchema: yup.SchemaOf<EnvFile> = yup.object({
  SERVER_URI: yup.string().required(),
  CLIENT_URI: yup.string().required(),
  UPS_URI: yup.string().required(),
  WP_ADMIN_URI: yup.string().required(),
  HOST_WS: yup.string().required(),
  PRODUCT_CREATION_ALLOWED: yup.boolean().required(),
  CACHE_EXPIRATION: yup.number().required(),
  RESEND_EMAIL_CODE_COOL_DOWN: yup.number().required(),
  IS_DEV: yup.boolean().default(false),
  I18N_DEBUG: yup.boolean().default(false),

  //Logger
  LOG_LEVEL: yup.mixed<LogLevel>().oneOf(Object.values(LogLevel)).required(),
  LOG_GROUP_NAME: yup.string().required(),
  LOG_STREAM_NAME: yup.string().required(),
  CLOUDWATCH_LOGGER_ENABLED: yup.boolean().required(),

  // AWS
  CLOUDWATCH_ACCESS_KEY: yup.string().required(),
  CLOUDWATCH_SECRET_ACCESS_KEY: yup.string().required(),
  CLOUDWATCH_REGION: yup.string().required(),
});
